// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import { chain, get, omit } from 'lodash'
import React, { useState } from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import RestrictedView from '../../auth/RestrictedView'
import { i18n } from '../../index'
import ChainRemindersTable from '../chainReminders/ChainRemindersTable'
import StationPage from '../station/StationPage'
import { RemindersForm } from './RemindersForm'
import { getStationReminders } from './RemindersQueries'
import { RemindersTable, RemindersTableItemData } from './RemindersTable'
import css from './reminders.css'

const StationRemindersPage = () => {
  const [editedReminder, setEditedReminder] = useState<RemindersTableItemData | undefined>()

  const transformReminders = (data) => {
    return chain(get(data, 'getStationReminders', []))
      .map((reminder) => omit(reminder, '__typename'))
      .orderBy((reminder) => reminder.name.toLowerCase())
      .value()
  }

  const onEdit = (reminder: RemindersTableItemData) => {
    setEditedReminder(reminder)
  }

  const onResetEditedReminder = () => {
    setEditedReminder(undefined)
  }

  return (
    <StationPage title={i18n.t('admin.stations.title.reminders')}>
      {({ station }) => (
        <Query
          query={getStationReminders}
          variables={{
            stationId: station.id,
          }}
          fetchPolicy='network-only'
        >
          {({ loading, error, data }) => (
            <Loader
              {...{
                loading,
                error,
              }}
            >
              <RestrictedView requiredPermission='manage_ownStation'>
                <RemindersForm
                  stationId={station.id}
                  editedReminder={editedReminder}
                  onResetEditedReminder={onResetEditedReminder}
                />
              </RestrictedView>
              <RemindersTable stationId={station.id} reminders={transformReminders(data)} onEdit={onEdit} />
              <Typography className={css.subHeading} variant='h6'>
                {i18n.t('admin.chain.tab.chainReminders')}
              </Typography>
              <ChainRemindersTable stationId={station.id} chainReminders={data?.getStationChainReminders ?? []} />
            </Loader>
          )}
        </Query>
      )}
    </StationPage>
  )
}

export default StationRemindersPage
